<template>
    <div class="footer-sm">
        <div class="container">
        <div class="row">
            <div class="col-md-4">
            <a class="footer-logo" href="#">Mauricio Sebastián Neira.</a>
            </div>
            <div class="col-md-4">
            <h6>&copy; mauriciosneira {{ new Date().getFullYear() }} Rights Reserved</h6>
            </div>
            <div class="col-md-4">
            <ul>
                <li><a target="_blank" href="https://www.instagram.com/mauriciosneira">Instagram</a></li>
                <li><a target="_blank" href="https://twitter.com/mauriciosneira">Twitter</a></li>
                <li><a target="_blank" href="https://www.linkedin.com/in/mauriciosneira/">Linkedin</a></li>
            </ul>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
}
</script>

<style lang="stylus">
@media only screen and (min-width: 240px)
    .footer-sm 
        padding 30px 0
        width:100%
        background rgba(30,166,154,0.1)
        background #f6f6fd
        text-align center
        height 120px
        h6 
            font-size 13px
            font-weight 500
            color #97a6b5
            letter-spacing 0
            display inline-block
        ul 
            list-style-type none
            text-align center
            margin-top 10px
            li 
                font-family "Montserrat"
                font-size 13px
                font-weight 400
                letter-spacing 0
                display inline-block
                margin-left 6px
                margin-right 6px
                a 
                    font-size 13px
                    font-weight 500
                    position relative
                    display inline-block
                    color #97a6b5
                    text-decoration none
                    &:before 
                        content ""
                        position absolute
                        width 100%
                        height 1px
                        bottom -3px
                        left 0
                        background-color #6d48e5
                        visibility hidden
                        -webkit-transform scaleX(0)
                        transform scaleX(0)
                        -webkit-transition all 0.2s ease-in-out 0s
                        transition all 0.2s ease-in-out 0s
                    &:hover 
                        &:before 
                            visibility visible
                            -webkit-transform scaleX(1)
                            transform scaleX(1)
	.col-md-4 
		&:nth-child(even) 
			text-align center
	.footer-logo 
		font-family 'Montserrat'
		font-size 18px
		font-weight 600
		color #6d48e5
		letter-spacing 0
		display block
		margin-bottom 15px
		text-decoration none
        
@media (min-width: 1200px)
    .container
        max-width: 1140px
</style>